export default "__VITE_ASSET__CVo9Gx3D__"